import React from 'react';

interface WarningIconProps {
  fill?: string;
  style?: React.CSSProperties;
}

export const WarningIconTestId = 'WarningIconTestId';

export const WarningIcon: React.FC<WarningIconProps> = (props) => {
  const { style, fill } = props;
  return (
    <span style={style} data-testid={WarningIconTestId}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill={fill || 'none'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.8155 15.6667L9.00001 3.29597L15.1845 15.6667H2.8155ZM1.55592 17.3334H16.4441C17.1043 17.3334 17.5337 16.6385 17.2384 16.0479L9.79435 1.15769C9.46706 0.503021 8.53295 0.503019 8.20566 1.15769L0.761578 16.0479C0.466326 16.6385 0.895721 17.3334 1.55592 17.3334ZM9.83334 14C9.83334 14.4603 9.46024 14.8334 9.00001 14.8334C8.53977 14.8334 8.16667 14.4603 8.16667 14C8.16667 13.5398 8.53977 13.1667 9.00001 13.1667C9.46024 13.1667 9.83334 13.5398 9.83334 14ZM10.25 7.33335H7.75001L8.16667 11.9167H9.83334L10.25 7.33335Z"
          fill={fill || '#C77221'}
        />
      </svg>
    </span>
  );
};
